import { AbstractGameController } from "@lib/titan2/dist/game/controller/AbstractGameController";
import { EventObject } from "@lib/titan2/dist/util/event/EventObject";
import { gsap } from "gsap";
import { FeatureFishFoodEvents } from "../view/abstract/display/features/fishfood/FeatureFishFood";
import { FeatureTransitionEvents } from "./FeatureTransitionController";
import { GameBigWinEvents } from "../view/abstract/display/GameBigWin";
import { Service } from "@lib/titan2-slingo/dist/api/Service";
import { GameEvent } from "./event/GameEvent";
import { SeededRandom } from "../utils/SeededRandom";
import { MainTransitionEvents } from "../view/abstract/display/GameMainTransition";
export class FeatureFishFoodController extends AbstractGameController {
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(FeatureFishFoodControllerEvents.BEGIN_FEATURE, this.handleBeginFeature);
    }
    async handleBeginFeature() {
        const seededRandomUserChoice = new SeededRandom(this.model.getGameInstanceId());
        const chanceGameData = this.model.getFishFoodChanceGameData();
        this.dispatchGame(FeatureFishFoodEvents.SHOW);
        if (Service.isReplay()) {
            await this.blockUntil(FeatureFishFoodEvents.FOOD_PICK_READY);
            await this.delayFor(1);
        }
        const picks = chanceGameData.getPrizePicks();
        const availableBagIndexes = Array.from({ length: 25 }, (x, i) => i);
        const availableMouseIndexes = Array.from({ length: 3 }, (x, i) => i);
        for (const pick of picks) {
            let index;
            if (Service.isReplay()) {
                await this.delayFor(0.5);
                index = this.model.consumeNextUserChoice();
                if (index === null) {
                    index = seededRandomUserChoice.pickFromArray(availableBagIndexes);
                }
            }
            else {
                index = (await this.blockUntil(FeatureFishFoodEvents.PICK_SELECTED)).getPayload()["index"];
                this.dispatchGame(GameEvent.createUserchoiceMadeEvent({ choice: index }));
            }
            availableBagIndexes.splice(availableBagIndexes.indexOf(index), 1);
            this.dispatchGame(new EventObject(FeatureFishFoodEvents.REVEAL_PICK.getType(), { index, type: pick.type, count: pick.pickCount, cumulativeWinAmount: pick.cumulativePayout, lastPick: pick.lastPick }));
        }
        this.dispatchGame(FeatureFishFoodEvents.DISABLE_PICKS);
        await this.delayFor(2);
        this.dispatchGame(new EventObject(FeatureFishFoodEvents.SHOW_MISSED_PICKS.getType(), { missedPicks: chanceGameData.getMissedPicks() }));
        await this.blockUntil(FeatureFishFoodEvents.SHOW_MISSED_PICKS_COMPLETE);
        await this.delayFor(0.5);
        this.dispatchGame(FeatureFishFoodEvents.SHOW_TURTLES);
        await this.blockUntil(FeatureFishFoodEvents.TURTLE_PICK_READY);
        const pickedTurtleValue = chanceGameData.getTurtlePickAmount();
        const missedTurtleValues = chanceGameData.getTurtleMissedPickAmounts();
        const totalWin = chanceGameData.getTotalWin();
        let index;
        if (Service.isReplay()) {
            await this.delayFor(1);
            index = this.model.consumeNextUserChoice();
            if (index === null) {
                index = seededRandomUserChoice.pickFromArray(availableMouseIndexes);
                availableMouseIndexes.splice(availableMouseIndexes.indexOf(index), 1);
            }
        }
        else {
            index = (await this.blockUntil(FeatureFishFoodEvents.TURTLE_PICK_SELECTED)).getPayload()["index"];
            this.dispatchGame(GameEvent.createUserchoiceMadeEvent({ choice: index }));
        }
        this.dispatchGame(new EventObject(FeatureFishFoodEvents.REVEAL_TURTLE_PICK.getType(), { index, totalWin, pickValue: pickedTurtleValue, missedValues: missedTurtleValues }));
        await this.delayFor(4);
        this.dispatchGame(FeatureTransitionEvents.TRANSITION_WIN_PARTICLE);
        this.dispatchGame(GameBigWinEvents.PLAY);
        await this.blockUntil(GameBigWinEvents.COMPLETE);
        this.dispatchGame(FeatureTransitionEvents.TRANSITION_BACK_TO_BASE_GAME);
        await this.blockUntil(MainTransitionEvents.BLACKOUT_MID_POINT);
        this.dispatchGame(FeatureFishFoodEvents.CLEAR);
    }
    createModel() {
        super.createModel();
        this.model = this.baseModel;
    }
    async blockUntil(event) {
        return new Promise(resolve => {
            this.registerGame(event, (recievedEvent) => {
                this.unregisterGame(event);
                resolve(recievedEvent);
            });
        });
    }
    async delayFor(timeInSeconds) {
        return new Promise(resolve => {
            gsap.delayedCall(timeInSeconds, resolve);
        });
    }
}
export class FeatureFishFoodControllerEvents {
}
FeatureFishFoodControllerEvents.BEGIN_FEATURE = new EventObject("FeatureFishFoodControllerEvents.BEGIN_FEATURE");
//# sourceMappingURL=FeatureFishFoodController.js.map